import { render, staticRenderFns } from "./RsaConfigurazioneParametriVitaliPresidioListComponent.vue?vue&type=template&id=7a9a8800"
import script from "./RsaConfigurazioneParametriVitaliPresidioListComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneParametriVitaliPresidioListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports